// extracted by mini-css-extract-plugin
export var all_wrapper = "styles-module--all_wrapper--4ea20";
export var description = "styles-module--description--a70be";
export var hover_logo = "styles-module--hover_logo--58aea";
export var hover_logo_wrapper = "styles-module--hover_logo_wrapper--9c369";
export var hover_wrapper = "styles-module--hover_wrapper--ff805";
export var thumb_wrapper = "styles-module--thumb_wrapper--9cdd5";
export var title = "styles-module--title--b59f5";